import { mutate } from 'swr';
import settings from '/@/core/settings';
import { axFetch } from '/@/store/session/actions';

export const getNSRecommendationsFromAPI = async ({ country }: { country: string }) => {
    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/nitrogen-recommendation/me/?country=${country}`,
        window.location.origin
    );

    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};

export const getNitrogenSourcesFromAPI = async () => {
    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/nitrogen-recommendation/sources/?page_size=1000`,
        window.location.origin
    );
    const res = await axFetch.get(apiUrl.toString());
    return res.data.results.map((source) => ({ ...source, label: source.name, value: source.id }));
};

export const getNSRecommendationFromAPI = async ({ recoId }) => {
    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/nitrogen-recommendation/me/${recoId.recoId}/`,
        window.location.origin
    );
    const res = await axFetch.get(apiUrl.toString());
    return res.data;
};

export const updateNSRecommendationFromAPI = async ({
    id,
    plantingDate,
    applicationDate,
    estimatedApplicationDate,
    hybrid,
    productName,
    nitrogenSource,
    technique,
    distributor,
    phone,
    companyName,
    cropMonitoring,
    managementZoneFilesIds,
    managementZones,
    type,
}) => {
    if (!id) return;

    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/nitrogen-recommendation/me/${id}/`,
        window.location.origin
    );
    const res = await axFetch.patch(apiUrl.toString(), {
        plantingDate: plantingDate,
        application_date: applicationDate,
        estimated_application_date: estimatedApplicationDate,
        hybrid,
        productName: productName,
        nitrogen_source: nitrogenSource,
        technique,
        distributor,
        phone,
        company_name: companyName,
        crop_monitoring: cropMonitoring,
        management_zone_files_ids: managementZoneFilesIds,
        management_zones: managementZones,
        type,
    });
    mutate({ key: 'myNSRecommendations', recoId: id });
    mutate((key) => key?.key == 'allMyNSRecommendations');
    return res.data;
};

export const createNSRecommendationFromAPI = async ({
    status,
    appInstance,
    field,
    plantingDate,
    applicationDate,
    estimatedApplicationDate,
    hybrid,
    productName,
    nitrogenSource,
    technique,
    distributor,
    phone,
    companyName,
    cropMonitoring,
    managementZoneFilesIds,
    managementZones,
    type,
}) => {
    const apiUrl = new URL(`${settings.urls.apiDomain}/core/v1/nitrogen-recommendation/me/`, window.location.origin);
    const res = await axFetch.post(apiUrl.toString(), {
        status,
        appInstance: appInstance,
        field,
        plantingDate: plantingDate,
        application_date: applicationDate,
        estimated_application_date: estimatedApplicationDate,
        hybrid,
        productName: productName,
        nitrogen_source: nitrogenSource,
        technique,
        distributor,
        phone,
        company_name: companyName,
        crop_monitoring: cropMonitoring,
        management_zone_files_ids: managementZoneFilesIds,
        management_zones: managementZones,
        type,
    });
    mutate((key) => key?.key == 'allMyNSRecommendations');
    return res.data;
};

export const deleteNSRecommendationFromAPI = async ({ recoId }) => {
    if (!recoId) return;

    const apiUrl = new URL(
        `${settings.urls.apiDomain}/core/v1/nitrogen-recommendation/me/${recoId}/`,
        window.location.origin
    );
    const res = await axFetch.delete(apiUrl.toString());
    mutate({ key: 'myNSRecommendations', recoId });
    mutate((key) => key?.key == 'allMyNSRecommendations');
    return res.data;
};
